// extracted by mini-css-extract-plugin
module.exports = {"fat":"button_fat__vMiKJ"};